<template>
  <div class="top relative overflow-hidden">
    <div class="top-text">智慧生物样本库</div>
    <!-- <div class="titlebar absolute pin-b w-full text-center">
      <ButtonGroup class="">
        <Button>我要存储</Button>
        <Button>我要建设方案</Button>
        <Button>我要寻求帮助</Button>
      </ButtonGroup>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'SampleTop',
  props: {},
  mixins: [],
  components: {},
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.top {
  height: 27.08vw; //520px;
  background-image: url('/static/images/background/sample.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  .titlebar {
    height: 6.93vw; //133px;
    line-height: 6.93vw; //133px;
    background: rgba(58, 153, 167, 0.7);
  }
  .ivu-btn {
    border-radius: 8px;
    width: 10.94vw; //210px;
    font-size: 0.9375vw; //18px;

    color: #ffffff;
    background-color: $c-transparent;
    padding: 1.04vw 2.6vw; //20px 50px;
    transition: all 1s;
    -moz-transition: all 1s;
    -webkit-transition: all 1s;
    -o-transition: all 1s;
    &:hover {
      color: #1d778f;
      background-color: $c-white;
      border-color: $c-white;
    }
  }
}
</style>
